import { availableLocales, FALLBACK_LANGUAGE, type Language } from './locales';

// Language tags are case-insensitive (BCP 47), so tags are compared in lower case
const matchesLocalePrefix = (tag: string, locale: Language): boolean => {
  const lowerCaseLocale = locale.toLowerCase();
  return tag === lowerCaseLocale || tag.startsWith(`${lowerCaseLocale}-`);
};

export const resolveSupportedLanguage = (
  language?: string | null,
): Language | undefined => {
  if (!language) return undefined;

  const tag = language.toLowerCase();

  const directMatch = availableLocales.find(
    (locale) => locale.toLowerCase() === tag,
  );
  if (directMatch) return directMatch;

  const localesBySpecificity = [...availableLocales].sort(
    (a, b) => b.length - a.length,
  );

  return localesBySpecificity.find((locale) =>
    matchesLocalePrefix(tag, locale),
  );
};

export const getInitialLanguage = (
  searchParams = new URLSearchParams(document.location.search),
): Language =>
  resolveSupportedLanguage(searchParams.get('lang')) ?? FALLBACK_LANGUAGE;
